import React from 'react'
import { injectIntl } from 'react-intl'
import FinanceEventIcon from 'components/FinanceEventIcon'
import { parseEventState } from 'pages/finance/utils'
import classnames from 'classnames'
import { withLocation, withNotifications } from 'redux/enhancers'
import style from './style.module.scss'

const WithdrawalSnippet = ({ data, intl: { formatMessage }, unread, notificationId, referenceId, redirectTo, readNotice}) => {
  if (!data)
    return null

  const clickHandler = () => {
    redirectTo(`/finance?eventId=${referenceId}&notificationId=${notificationId}`)
    readNotice(notificationId)
  }

  return (
    <div
      className={classnames(style.withdrawalSnippet, { [style.unread]: unread })}
      onClick={clickHandler}
      onKeyPress={clickHandler}
      role="button"
      tabIndex={0}
    >
      <FinanceEventIcon type="EventByWithdrawal" status={parseEventState(data.withdrawal.state)} />
      <div className={style.info}>
        {formatMessage({ id: 'notifications.notification.withdrawal.title' })}
        <br />
        {data.withdrawal.state === 'approved' && formatMessage({ id: 'notifications.notification.withdrawal.approved' })}
        {data.withdrawal.state === 'rejected' && formatMessage({ id: 'notifications.notification.withdrawal.rejected' })}
        {data.withdrawal.state === 'canceled' && formatMessage({ id: 'notifications.notification.withdrawal.canceled' })}
      </div>
    </div>
  )
}

export default withLocation(withNotifications(injectIntl(WithdrawalSnippet)))
